import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { listPlacements } from "../../api/clientVendorDirectoryRankingApi";
import ClientVendorDirectorySubnav from "../../components/casamap/admin/ClientVendorDirectorySubnav";
import ClientVendorDirectoryRankingSubnav from "../../components/casamap/admin/ClientVendorDirectoryRankingSubnav";
import { ClientPortalError, ClientPortalLoading } from "../../components/clientPortal/ClientPortalStates";
import { formatClientDate, formatStatusLabel } from "../../utils/clientPortalFormat";
import { useLocale } from "../../intl";
import "../../styles/casamapaVendorDirectoryAdmin.css";

const COPY_PREFIX = "realEstate.casaMapa.admin.vendorDirectoryWorkspace.ranking.placements";

export default function ClientVendorDirectoryRankingPlacementListPage() {
  const { clientViewId } = useParams();
  const { t, locale } = useLocale();
  const [placements, setPlacements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const body = await listPlacements(clientViewId);
      setPlacements(body.placements || []);
    } catch (error) {
      setErrorMessage(error.message || t(`${COPY_PREFIX}.loadError`));
    } finally {
      setLoading(false);
    }
  }, [clientViewId, t]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div className="page-content cvd-admin">
      <ClientVendorDirectorySubnav clientViewId={clientViewId} />
      <ClientVendorDirectoryRankingSubnav clientViewId={clientViewId} />
      <h1 className="cvd-admin__title">{t(`${COPY_PREFIX}.title`)}</h1>
      <p className="lede">{t(`${COPY_PREFIX}.intro`)}</p>
      {loading ? <ClientPortalLoading message={t(`${COPY_PREFIX}.loading`)} /> : null}
      {errorMessage ? <ClientPortalError message={errorMessage} onRetry={load} /> : null}
      {!loading && !errorMessage ? (
        <div className="cvd-table-wrap">
          <table className="cvd-table">
            <thead>
              <tr>
                <th>{t(`${COPY_PREFIX}.table.vendor`)}</th>
                <th>{t(`${COPY_PREFIX}.table.type`)}</th>
                <th>{t(`${COPY_PREFIX}.table.category`)}</th>
                <th>{t(`${COPY_PREFIX}.table.label`)}</th>
                <th>{t(`${COPY_PREFIX}.table.priority`)}</th>
                <th>{t(`${COPY_PREFIX}.table.status`)}</th>
                <th>{t(`${COPY_PREFIX}.table.window`)}</th>
              </tr>
            </thead>
            <tbody>
              {placements.map((placement) => (
                <tr key={placement.id}>
                  <td>{placement.vendorName || placement.vendorId}</td>
                  <td>{formatStatusLabel(placement.placementType)}</td>
                  <td>{placement.categoryKey || "—"}</td>
                  <td>{placement.label || "—"}</td>
                  <td>{placement.positionPriority}</td>
                  <td>{formatStatusLabel(placement.status)}</td>
                  <td>
                    {formatClientDate(placement.startsAt, locale)} –{" "}
                    {placement.endsAt ? formatClientDate(placement.endsAt, locale) : t(`${COPY_PREFIX}.openEnded`)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
